import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    areaList: []
  },
  mutations: {
    updateAreaList(state,list) {
      state.areaList = list;
    }
  },
  actions: {
  },
  modules: {
  }
})
